import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { hot } from "react-hot-loader";
// import {
// } from "./selectors";
const RowCellContainer = styled.div`
    width: 100%;
    background-color: #3e50b5;
    color: white;
    grid-column-start: 1;
    grid-column-end: 1;
    grid-row-start: ${props => props.row + 2};
    grid-row-end: ${props => props.row + 2};
    display: grid;
    grid-template-rows: 20px 1fr;
    grid-template-columns: 1fr;
    overflow: hidden;
`;

const RowCellHeader = styled.div`
    grid-row-start: 1;
    grid-row-end: 1;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 20px;
    font-size: 12px;
    overflow: hidden;
`;

const RowCellBody = styled.div`
    grid-row-start: 2;
    grid-row-end: 2;
    display: grid;
    padding: 7px;
    font-size: 20px;
    font-weight: bold;
    overflow: hidden;
`;

const HeaderIconButton = styled(IconButton)`
    grid-column-start: 2;
    grid-column-end: 2;
    max-width: 20px;
    max-height: 20px;
    color: white;
    overflow: hidden;
`;

const HeaderIcon = styled(MenuIcon)`
    max-width: 16px;
    max-height: 16px;
    color: white;
`;

const StyledMenuItem = styled(MenuItem)`
    max-height: 10px;
`;

class RowCell extends React.Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: null, editRowCellModalOpen: false, confirmDeleteModalOpen: false };
    }
    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    render() {
        return (
            <RowCellContainer row={this.props.eventRowIndex}>
                <RowCellHeader>
                    <HeaderIconButton
                        color="primary"
                        aria-owns={this.state.anchorEl ? "simple-menu" : undefined}
                        aria-haspopup="true"
                        onClick={this.handleClick}
                    >
                        <HeaderIcon />
                    </HeaderIconButton>
                    <Menu
                        id="simple-menu"
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                    >
                        <StyledMenuItem
                            onClick={() => {
                                this.props.setEditRowCellModalOpen();
                                this.handleClose();
                            }}
                        >
                            Edit
                        </StyledMenuItem>
                        <StyledMenuItem
                            onClick={() => {
                                this.props.setConfirmDeleteModalOpen();
                                this.handleClose();
                            }}
                        >
                            Delete
                        </StyledMenuItem>
                    </Menu>
                </RowCellHeader>
                <RowCellBody>{this.props.title}</RowCellBody>
            </RowCellContainer>
        );
    }
}

export default hot(module)(
    connect(
        store => {
            return {};
        },
        {}
    )(RowCell)
);
